// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueGtm from 'vue-gtm'
import VueAnalytics from 'vue-analytics'
import 'vue-awesome/icons'
import inViewportDirective from 'vue-in-viewport-directive'
import VueResource from 'vue-resource'
import Meta from 'vue-meta'

Vue.config.productionTip = false
Vue.directive('in-viewport', inViewportDirective)
// Create the event bus by creating a new Vue instance and
// binding it somehwere accessible. If you bind it to the
// Vue prototype, you can access it within your components
// like this:
//
// Emit an event
// this.$bus.$emit('myEvent', {data: true})
//
// React to an event
// this.$bus.$on('myEvent', (message) => {console.log(message})
Vue.prototype.$bus = new Vue({})
Vue.use(Meta)
Vue.use(VueResource)
Vue.use(VueGtm, {
  id: 'GTM-NCRCTXR', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})
Vue.use(VueAnalytics, {
  id: 'UA-10276440-45',
  checkDuplicatedScript: true,
  router
})

require('./assets/style.scss')
require('velocity-animate')

router.beforeEach((to, from, next) => {
  // document.title = to.meta.title
  if (router.app.$root.$data) {
    router.app.$root.$data.to = to
    router.app.$root.$data.from = from
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>',
  data: {
    // site: 'http://bsd.blacksheep.design'
    site: 'https://bsd.nz'
  }
})



// WEBPACK FOOTER //
// ./src/main.js